'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoGearB = function IoGearB(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 23h-3.4c-0.4 1.1-0.8 2.1-1.4 3l2.5 2.5-4.2 4.2-2.6-2.5c-0.9 0.6-1.8 0.9-2.9 1.2v3.6h-6v-3.6c-1-0.3-2-0.6-2.9-1.2l-2.6 2.5-4.2-4.2 2.5-2.5c-0.6-0.9-1.1-1.9-1.4-3h-3.4v-6h3.4c0.3-1.1 0.7-2.2 1.2-3.2l-2.3-2.3 4.2-4.2 2.2 2.2c1.1-0.6 2.2-1 3.3-1.3v-3.2h6v3.2c1.1 0.3 2.2 0.7 3.2 1.3l2.3-2.2 4.2 4.2-2.3 2.3c0.5 1 1 2.1 1.2 3.2h3.4v6z m-15 1.2c2.3 0 4.2-1.9 4.2-4.2s-1.9-4.2-4.2-4.2-4.2 1.9-4.2 4.2 1.9 4.2 4.2 4.2z' })
        )
    );
};

exports.default = IoGearB;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/gear-b.js
// module id = 2065
// module chunks = 0